import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelToggleMarketingCommunications} from "../../actions/AccountApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class ToggleMarketingCommunicationsFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(_values) {
    return this.props.toggleMarketingCommunications({customerId: this.props.customerId})
      .then((response) => {
        if (response.data.toggleMarketingCommunications.errors.length <= 0) {
          this.props.cancelToggleMarketingCommunications();
        } else {
          let errors = createValidationErrors(response.data.toggleMarketingCommunications.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelToggleMarketingCommunications();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message="Are you sure you want to toggle Marketing Communications for this customer?"
        submitLabel="Toggle"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const TOGGLE_MARKETING_COMMUNICATIONS = gql`
  mutation toggleMarketingCommunications($data: CustomerIdInput!) {
    toggleMarketingCommunications(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(TOGGLE_MARKETING_COMMUNICATIONS, {
    props: ({ mutate }) => ({
      toggleMarketingCommunications: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelToggleMarketingCommunications})(withMutation(ToggleMarketingCommunicationsFormContainer));